var React = require('react');

function Terminal (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"0.7","y":"0.8","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"14.4","height":"14.5","key":0}),React.createElement("polyline",{"fill":"none","stroke":"transparent","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t4.4,6 7.9,8 4.4,10 \t","key":1}),React.createElement("line",{"fill":"none","stroke":"transparent","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"7.7","y1":"12","x2":"11.8","y2":"12","key":2})]));
}

Terminal.displayName = "Terminal";

Terminal.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Terminal;

Terminal.default = Terminal;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/terminal.svg
// module id = ../icon/src/icons/terminal.svg
// module chunks = 0